import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Fade } from '@material-ui/core';
import axios from 'axios';
import classNames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import * as yup from "yup";
import { CircularLoading } from '../../../../..';
import MedicamentoIcon from "../../../../../../assets/img/icon-medicamento.svg";
import MovimentacaoIcon from "../../../../../../assets/img/icon-movimentacao.svg";
import { useGetAutorizacaoById } from '../../../../../../data/api/gestao/autorizacao/autorizacao-by-id';
import { useEditarOperacaoPerda, useGetPerdaById } from '../../../../../../data/api/gestao/perdas/perdas';
import { useToastSaurus } from '../../../../../../services/app';
import { formatarDataInput } from '../../../../../../utils/formatDateInput';
import { ButtonModalHeader } from '../../../../../components/controles/buttons/button-modal-header';
import { AvancarIcon, SalvarIcon, VoltarIcon } from '../../../../../components/icons';
import { ModalHeader } from '../../../../../components/modal-header';
import { Wizard } from "../../../../../components/wizard/wizard-component";
import { WizardStep } from '../../../../../components/wizard/wizard-model';
import { ETipoOperacaoMovimentacao } from '../../../envio-movimentacao/models/envio-movimentacao.model';
import { ControleMedicamentoLotes, EPerdaPassos, MedicamentoPerda, OperacaoPerdaRequest, PerdaMedicamentoLote, PerdaModel } from '../../models/perdas-models';
import { PerdaMedicamentoLotes } from './perda-medicamento-lotes/perda-medicamento-lotes';
import { PerdaMedicamentosForm } from './perda-medicamentos-form';
import { PerdaMovimentacaoForm } from './perda-movimentacao-form';
import { useStyles } from './perdas-cadastro-styles';

export const PerdaCadastroPage = (props: any) => {
    const [passoPerda, setPassoPerda] = useState(0);
    const [formPerda, setFormPerda] = useState({} as PerdaModel);
    const [controleMedicamentos, setControleMedicamentos] = useState<ControleMedicamentoLotes>(new ControleMedicamentoLotes());
    const [isVisualizacao, setIsVisualizacao] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const styles = useStyles();

    const { getAutorizacaoById } = useGetAutorizacaoById();
    const { getPerdaById } = useGetPerdaById();
    const { editarOperacaoPerda } = useEditarOperacaoPerda();
    const { showToast, showToastPersonalizado } = useToastSaurus();

    const operacaoId = props.operacaoId;
    const perdaId = props.perdaId;
    const dataHoraLancamento = props.dataHoraLancamento;

    const schema = yup
        .object()
        .shape({
            motivoPerda: yup.number().required("Motivo da Perda é obrigatório!"),
            data: yup.string().required("Data é obrigatória!"),
            hora: yup.string().required("Hora é obrigatória!"),
        });

    const {
        formState,
        register,
        setError
    } = useForm<PerdaModel>({
        criteriaMode: 'all',
        mode: 'onBlur' && 'onTouched',
        resolver: yupResolver(schema)
    });

    const getPerda = useCallback(async () => {
        try {

            const res = await getAutorizacaoById(operacaoId);

            if (res.erro) {
                props.fecharModal(true);
                setIsLoading(false);
                return showToast("error", `${res.erro}`, 5000, 'top-center');
            }

            const perda = res.resultado?.data.perda;

            setFormPerda(new PerdaModel(
                res.resultado?.data.id,
                res.resultado?.data.operacaoAutorizacaoId,
                res.resultado?.data.dataHoraLancamento,
                formatarDataInput(perda.dataHoraLancamento).data,
                formatarDataInput(perda.dataHoraLancamento).hora,
                perda.motivoPerda,
                perda.medicamentos
            ));

            setIsLoading(false);
        } catch (e: any) {
            if (axios.isCancel(e))
                return;

            console.error("error", e.message);
            toast.error('O processo resultou em um erro interno da API');
        }
    }, [getAutorizacaoById, operacaoId]);

    useEffect(() => {
        if (!operacaoId)
            return;

        getPerda();
    }, [operacaoId]);

    const getPerdaVisualizacao = useCallback(async () => {
        try {
            setIsVisualizacao(true);
            const res = await getPerdaById(perdaId, dataHoraLancamento);

            if (res.erro) {
                props.fecharModal(true);
                setIsLoading(false);
                return showToast("error", `${res.erro}`, 5000, 'top-center');
            }

            const perda = res.resultado?.data;

            setFormPerda(new PerdaModel(
                perda.id,
                perda.operacaoAutorizacaoId,
                perda.dataHoraLancamento,
                formatarDataInput(perda.dataHoraLancamento).data,
                formatarDataInput(perda.dataHoraLancamento).hora,
                perda.motivoPerda,
                perda.medicamentos,
            ));

            setIsLoading(false);
        } catch (e: any) {
            console.error("error", e.message);
            toast.error('O processo resultou em um erro interno da API');
        }
    }, [getPerdaById, perdaId]);

    useEffect(() => {
        if (!perdaId)
            return;

        getPerdaVisualizacao();
    }, [perdaId]);

    const steps: WizardStep[] = [
        {
            label: 'Dados da Movimentação',
            icon: <img src={MovimentacaoIcon} alt="" />
        },
        {
            label: 'Medicamentos',
            icon: <img src={MedicamentoIcon} alt="" />
        }
    ];

    const editarMedicamentos = useCallback((medicamentos: MedicamentoPerda[]) => {
        setControleMedicamentos({
            exibir: true,
            medicamentoLotes: medicamentos,
        });
    }, []);

    const salvarLotes = (lotesSelecionados: PerdaMedicamentoLote[], medicamento: MedicamentoPerda) => {
        if (lotesSelecionados?.length == 0) return;

        let medicamentosEdicao = [...formPerda.medicamentos];
        var medicamentosEdicaoControle = medicamentosEdicao.filter(x => x.medicamentoId != medicamento.medicamentoId);

        while (lotesSelecionados?.length) {
            const loteAtual = lotesSelecionados[0];

            let medicamentoAtual = medicamentosEdicaoControle
                .find(m => m.codigoAnvisa === medicamento.codigoAnvisa && !m.lote);

            if (medicamentoAtual) {
                let medIndex = medicamentosEdicaoControle.indexOf(medicamentoAtual);

                medicamentosEdicaoControle[medIndex] = {
                    ...medicamentoAtual,
                    lote: loteAtual.lote,
                    validade: loteAtual.dataValidade,
                    fabricacao: loteAtual.dataFabricacao
                }
            } else {
                medicamentosEdicaoControle.push({
                    ...medicamento,
                    lote: loteAtual.lote,
                    validade: loteAtual.dataValidade,
                    fabricacao: loteAtual.dataFabricacao
                } as MedicamentoPerda)
            }

            lotesSelecionados[0].quantidadePerdida -= 1;
            if (loteAtual.quantidadePerdida === 0)
                lotesSelecionados = lotesSelecionados.slice(1);
        }

        setFormPerda({ ...formPerda, medicamentos: medicamentosEdicaoControle });
        setControleMedicamentos(new ControleMedicamentoLotes());

        showToast('success', "Lote adicionado com sucesso!", 5000, 'top-center');
    }

    const avancarStep = async (step: number) => {

        if (await validarPerda()) {
            setPassoPerda(step);
            return;
        }

        return showToastPersonalizado("error", "Preencha os campos obrigatórios!", 5000, 'top-center');

    }

    const validarPerda = async () => {

        try {

            await schema.validate({
                data: formPerda.data,
                hora: formPerda.hora,
                motivoPerda: formPerda.motivoPerda
            }, { abortEarly: false });

            return true;

        } catch (error) {

            const validationError = error as yup.ValidationError;

            validationError?.inner?.forEach(err => {
                const path = err.path?.toString();

                if (path && Object.prototype.hasOwnProperty.call(schema.fields, path)) {
                    setErrorField(path, err.message);
                }

            });

            return false;
        }
    }

    function setErrorField(path: string, errorMensage: string) {

        switch (path) {

            case 'data':
                setError('data', {
                    type: 'manual',
                    message: errorMensage,
                });
                break;

            case 'hora':
                setError('hora', {
                    type: 'manual',
                    message: errorMensage,
                });
                break;

            case 'motivoPerda':
                setError('motivoPerda', {
                    type: 'manual',
                    message: errorMensage,
                });
                break;

            default:
                break;
        }

    }

    const salvarPerda = async (deveAutorizar: boolean) => {
        var formIsValid = await schema.isValid(formPerda);

        if (!formIsValid)
            return showToast("error", "Campos obrigatórios não preenchidos!", 5000, 'top-center');

        if (deveAutorizar) {
            const hasMedicamentoSemEstoque = formPerda.medicamentos.some(x => !x.lote);

            if (hasMedicamentoSemEstoque)
                return showToast("error", "O lote do medicamento não foi informado!", 5000, 'top-center');
        }

        const dataHoraLancamento = new Date(`${formPerda.data}T${formPerda.hora}:00.000Z`);
        formPerda.dataHoraLancamento = dataHoraLancamento;

        const perda = new OperacaoPerdaRequest(
            formPerda.id,
            formPerda.operacaoAutorizacaoId,
            ETipoOperacaoMovimentacao.Perda,
            formPerda.dataHoraLancamento,
            deveAutorizar,
            formPerda
        );

        setIsLoading(true);

        const operacaoSalva = await editarOperacaoPerda(perda);

        if (operacaoSalva.erro) {
            setIsLoading(false);
            return showToast("error", `${operacaoSalva.erro}`, 5000, 'top-center');
        }

        if (deveAutorizar)
            showToast("success", 'Perda autorizada com sucesso!');
        else
            showToast("success", 'Perda editada com sucesso!');

        setIsLoading(false);
        props.fecharModal(true);
    };

    const fechar = () => controleMedicamentos.exibir
        ? setControleMedicamentos(new ControleMedicamentoLotes())
        : props.fecharModal();

    return (
        <>
            <Fade in mountOnEnter unmountOnExit>
                <div className={`flex-column w-100 h-100 ${styles.defaultContainer}`} >

                    <ModalHeader
                        title={'Perdas'}
                        leftArea={
                            <ButtonModalHeader
                                tooltip="Voltar"
                                icon={<VoltarIcon tipo="MODAL_HEADER" />}
                                onClick={fechar}
                            />
                        }
                    />

                    {isLoading ? <CircularLoading tipo="FULLSIZED" /> :
                        <>
                            {controleMedicamentos.exibir
                                ? <PerdaMedicamentoLotes
                                    medicamentos={controleMedicamentos.medicamentoLotes}
                                    salvarLotesPerda={salvarLotes}
                                    visualizacao={isVisualizacao} />
                                : (
                                    <div className={`flex-column w-100 ${styles.formPadding, styles.formHeight}`} >
                                        <Wizard steps={steps} activeStep={passoPerda} setActiveStep={step => avancarStep(Number(step))} />

                                        <div className={`flex-column ${isVisualizacao ? styles.formContainerVisualizacao : styles.formContainer}`}>
                                            {
                                                passoPerda === EPerdaPassos.Movimentacao ? (
                                                    <PerdaMovimentacaoForm
                                                        register={register}
                                                        formState={formState}
                                                        visualizacao={isVisualizacao}
                                                        perda={formPerda}
                                                        setPerda={setFormPerda}
                                                    />
                                                ) : (
                                                    <PerdaMedicamentosForm
                                                        register={register}
                                                        formState={formState}
                                                        visualizacao={isVisualizacao}
                                                        perda={formPerda}
                                                        setPerda={setFormPerda}
                                                        editarMedicamentoLotes={editarMedicamentos}
                                                    />
                                                )
                                            }
                                        </div>


                                        <div className={`flex-row w-100 ${styles.buttonContainer}`}>
                                            {passoPerda === EPerdaPassos.Movimentacao ?
                                                <div className={classNames(styles.buttonStyle, styles.darkButton)}>
                                                    <Button onClick={() => avancarStep(passoPerda + 1)} variant="text" className="h-100 w-100">
                                                        <div className={`flex-row ${styles.buttonLabel} ${styles.whiteLabel}`}>
                                                            <AvancarIcon class={styles.iconSize} />
                                                            Avançar
                                                        </div>
                                                    </Button>
                                                </div> :
                                                <>
                                                    {
                                                        !isVisualizacao && (
                                                            <>
                                                                <div className={classNames(styles.buttonStyle, styles.whiteButton)}>
                                                                    <Button onClick={() => salvarPerda(false)} variant="text" className="h-100 w-100">
                                                                        <div className={`flex-row ${styles.buttonLabel} ${styles.darkLabel}`}>
                                                                            <SalvarIcon class={styles.iconSize} />
                                                                            Salvar
                                                                        </div>
                                                                    </Button>
                                                                </div>
                                                                <div className={classNames(styles.buttonStyle, styles.darkButton)}>
                                                                    <Button onClick={() => salvarPerda(true)} variant="text" className="h-100 w-100">
                                                                        <div className={`flex-row ${styles.buttonLabel} ${styles.whiteLabel}`}>
                                                                            <AvancarIcon class={styles.iconSize} />
                                                                            Autorizar
                                                                        </div>
                                                                    </Button>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </>
                                            }
                                        </div>
                                    </div>
                                )
                            }
                        </>
                    }
                </div>
            </Fade>
        </>
    );
};
